module.exports = __webpack_public_path__ + "media/video-2.ac8ade23.mp4";